import axios from "axios";
import { useEffect, useState } from "react";
import { endpoints } from "../api/endpoints";
import { LoggedUser } from "../models/Person";

export const useWhoami = () => {
  const [data, setData] = useState<LoggedUser>();

  const getMe = async () => {
    axios
      .get(endpoints.whoami)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getMe();
  }, []);

  return data;
};
